import React from 'react';
import { RegularPriceRow } from './regular';
import { usePriceRowContext } from '../../price-row-context';
import { useDispatch } from 'react-redux';
import {
  productPriceClick,
  productClickOutBounce,
} from 'src/areas/product/actions/product';
import type { IPriceRow } from '../types';
import type { ProductPriceClickStatus } from 'src/areas/product/actions/types';
import {
  TrackClickScope,
  trackOfferClickWithRevenue,
} from 'src/globals/tracking/conversion';

export const PriceRow: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IPriceRow>>
> = props => {
  const { item, index, className } = props;
  const { product } = usePriceRowContext();
  const rowKey = `${item.id}-${index}`;
  const dispatch = useDispatch();

  return (
    <RegularPriceRow
      key={rowKey}
      onClickOutBounce={() => {
        dispatch(
          productClickOutBounce({
            productId: product.id,
            priceId: item.id,
            storeName: item.store?.name,
          })
        );
      }}
      onPriceClick={(
        featured: boolean,
        status: ProductPriceClickStatus,
        isAlternative: boolean
      ) => {
        // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
        // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
        dispatch(
          productPriceClick(product.id, item, featured, status, isAlternative)
        );

        trackOfferClickWithRevenue({
          scope: isAlternative
            ? TrackClickScope.PRICE_LIST_EXPANDED
            : TrackClickScope.PRICE_LIST,
          offerId: item.id!,
          productId: product.id,
        });
      }}
      className={className}
    />
  );
};
